/* The YouTube player card. It stays on screen while a video plays: YouTube's
   terms require the embedded player to remain visible. */

.card {
  position: absolute;
  left: calc(14px + var(--safe-l));
  bottom: calc(120px + var(--safe-b));
  width: 248px;
  border-radius: var(--r-md);
  overflow: hidden;
  transition:
    transform 0.5s var(--ease),
    opacity 0.35s;
}

.hidden {
  display: none;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 8px 14px;
  font-size: 12px;
  font-weight: 600;
  color: var(--ink-2);
  letter-spacing: -0.01em;
}

.head button {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: var(--ink-3);
  transition: transform 0.35s var(--ease);
}

.head svg {
  width: 16px;
  height: 16px;
}

.body {
  height: 140px;
  transition: height 0.45s var(--ease);
  overflow: hidden;
}

.collapsed .body {
  height: 0;
}

.collapsed .head button {
  transform: rotate(180deg);
}

.mount,
.mount :global(iframe) {
  width: 248px;
  height: 140px;
  display: block;
  border: 0;
}

@media (max-width: 620px) {
  .card {
    width: 172px;
    right: calc(10px + var(--safe-r));
    left: auto;
    bottom: calc(160px + var(--safe-b));
  }

  .body {
    height: 98px;
  }

  .mount,
  .mount :global(iframe) {
    width: 172px;
    height: 98px;
  }
}
